import React from "react";
import { Modal, Row, Col, Button, FormInstance } from "antd";
import styles from "./PersonModals.module.scss";
import { useWindowSize } from "../../../hooks/useWindowSize";

type Props = {
  form: FormInstance;
  visible: boolean;
  setVisibility: Function;
  resetForm: Function;
  isDuplicateUserUnderSameCaregiver: boolean;
};

const DuplicateServiceUserModal: React.FC<Props> = ({
  form,
  visible,
  setVisibility,
  resetForm,
  isDuplicateUserUnderSameCaregiver,
}) => {
  const { width } = useWindowSize();

  const { firstName, lastName } = form.getFieldsValue([
    "firstName",
    "lastName",
  ]);

  const handleCancelAndClose = () => {
    setVisibility(false);
  };
  const handleAddSomeoneElse = () => {
    resetForm();
    setVisibility(false);
  };

  return (
    <Modal
      visible={visible}
      className={styles.duplicateServiceUserContainer}
      centered={width < 992}
      width={width < 992 ? "unset" : "546px"}
      footer={
        <Row justify="center" gutter={[15, 10]}>
          {isDuplicateUserUnderSameCaregiver ? (
            <>
              <Col>
                <Button
                  className={styles.cancel}
                  onClick={handleCancelAndClose}
                >
                  Cancel
                </Button>
              </Col>
              <Col>
                <Button
                  className={styles.addSomeoneElse}
                  onClick={handleAddSomeoneElse}
                >
                  Add Someone Else
                </Button>
              </Col>
            </>
          ) : (
            <Col>
              <Button className={styles.close} onClick={handleCancelAndClose}>
                Close
              </Button>
            </Col>
          )}
        </Row>
      }
    >
      <Row justify="center">
        <Col span={24} className={styles.title}>
          Duplicate Service User
        </Col>
        <Col span={24} className={styles.description}>
          {isDuplicateUserUnderSameCaregiver ? (
            <>
              <span className={styles.boldText}>
                {firstName} {lastName}
              </span>{" "}
              is already added as a service user.
            </>
          ) : (
            <>
              Sorry, <span className={styles.boldText}>{firstName}</span> is
              already being managed by a different caregiver and can't be added
              to this account.
            </>
          )}
        </Col>
      </Row>
    </Modal>
  );
};

export default DuplicateServiceUserModal;
